var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{attrs:{"width":"100%","height":"800","frameborder":"0","src":"http://172.25.0.9/old_dash"}})])
}]

export { render, staticRenderFns }